import React from "react";

const NRLogo: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="118.694"
      height="44.604"
      viewBox="0 0 118.694 44.604"
    >
      <defs>
        <clipPath id="clip-path">
          <path
            id="path16"
            d="M656.6-887.843h.013l0-.019Zm.013,0h0l-.017,0,0,0L604.92-871.05l20.949,5.528,30.7-22.285-22.1,24.535,16.012,4.231,6.134-28.8,0,0Zm-115.279,0,51.428,13.571,63.834-13.567,0,0Z"
            transform="translate(-541.332 887.862)"
            fill="#e35100"
          />
        </clipPath>
      </defs>
      <g
        id="Group_247"
        data-name="Group 247"
        transform="translate(-415.13 -133.2)"
      >
        <g
          id="g14"
          transform="translate(415.13 148.983)"
          clipPath="url(#clip-path)"
        >
          <g id="g20" transform="translate(-0.143 -0.255)">
            <g id="g22">
              <rect
                id="image24"
                width="116.136"
                height="29.278"
                fill="#e35100"
              />
            </g>
          </g>
        </g>
        <path
          id="path28"
          d="M-12.625,0h4.155l2.726,9.417h.038L-3.743,0H-.5L-3.438,13.591H-7.593l-2.784-9.4h-.038l-1.944,9.4H-15.6Z"
          transform="translate(432.12 133.2)"
          fill="#004d71"
        />
        <g id="g38" transform="translate(431.065 136.974)">
          <path
            id="path40"
            d="M-31.486-17.482c0-1.03-.4-1.906-1.62-1.906a2.468,2.468,0,0,0-2.459,1.906Zm.858,5.394a12.569,12.569,0,0,1-3.355.534c-3.2,0-4.918-1.964-4.918-4.384A5.568,5.568,0,0,1-33.125-21.6c2.516,0,4.4,1.277,4.4,4.173a10.347,10.347,0,0,1-.248,1.811h-6.786c.039,1.03.534,1.85,2.573,1.85a7.716,7.716,0,0,0,3.012-.667Z"
            transform="translate(38.901 21.599)"
            fill="#004d71"
          />
        </g>
        <path
          id="path44"
          d="M-1.784-12.705H-.278L.408-15.7H3.7l-.686,2.992H5.688L5.269-10.38h-2.8L1.875-7.712a8.94,8.94,0,0,0-.286,1.659c0,.648.8,1.009,1.468,1.009a3.671,3.671,0,0,0,1.067-.266L3.744-3.06a12.97,12.97,0,0,1-2.059.191c-1.7,0-3.412-.819-3.412-2.84a8.712,8.712,0,0,1,.306-1.963l.591-2.687H-2.2Z"
          transform="translate(444.247 149.908)"
          fill="#004d71"
        />
        <g id="g46" transform="translate(450.812 137.203)">
          <path
            id="path48"
            d="M-51.156-40.714h-3.851l-.1-6.939h-.038l-3.336,6.939h-3.87L-63.2-50.3h3.3l.058,6.939h.038l3.183-6.939H-52.6l.038,6.939h.038l3.107-6.939h3.355Z"
            transform="translate(63.204 50.303)"
            fill="#004d71"
          />
        </g>
        <g id="g50" transform="translate(467.32 136.974)">
          <path
            id="path52"
            d="M-25.655-9.872c-1.6,0-2.611,1.734-2.611,3.259,0,1.3.667,2.154,1.791,2.136,1.545,0,2.536-1.3,2.536-3.47,0-.991-.439-1.925-1.716-1.925m-1.067,7.72c-3.545,0-4.975-1.964-4.975-4.384.019-3.373,2.458-5.661,6.214-5.661,3.259,0,4.975,1.886,4.956,4.289,0,4-2.612,5.756-6.195,5.756"
            transform="translate(31.697 12.197)"
            fill="#004d71"
          />
        </g>
        <path
          id="path56"
          d="M-21.285-.969-21.666.995h.039A3.529,3.529,0,0,1-18.654-1.2a3.578,3.578,0,0,1,1.391.247l-.762,2.936a2.323,2.323,0,0,0-1.525-.4c-1.391,0-2.23,1.22-2.478,2.63l-.953,4.423H-26.3l1.525-7.092c.171-.819.324-1.639.419-2.5h3.069Z"
          transform="translate(505.149 138.172)"
          fill="#004d71"
        />
        <g id="g58" transform="translate(487.219 133.2)">
          <path
            id="path60"
            d="M-12.63,0h3.355l-1.754,8.025h.039L-7.808,4h3.774L-8.017,8.615l2.478,4.976H-9.218l-1.944-4.747H-11.2l-1.03,4.747H-15.6Z"
            transform="translate(15.604)"
            fill="#004d71"
          />
        </g>
        <g id="g62" transform="translate(498.79 133.2)">
          <path
            id="path64"
            d="M-21.608-23.957h1.43c1.583,0,2.8-.381,2.822-1.677,0-.973-.572-1.392-1.678-1.411H-20.96ZM-23.762-29.6h4.136c2.592.019,5.7.1,5.681,3.469A3.876,3.876,0,0,1-17.7-22.26v.038c1.067.1,1.411,1.545,1.6,2.422l.953,3.793h-3.412l-.686-3.47c-.344-1.772-.9-1.906-2.516-1.906h-.381l-1.125,5.376H-26.7Z"
            transform="translate(26.697 29.599)"
            fill="#004d71"
          />
        </g>
        <g id="g66" transform="translate(511.389 136.993)">
          <path
            id="path68"
            d="M-18.052-33.185a2.523,2.523,0,0,0,2.516-2.269,4.988,4.988,0,0,0-.877-.058c-1.582-.056-2.745.515-2.745,1.354a1.049,1.049,0,0,0,1.106.972m2.211.648-.039-.039v.039a3.68,3.68,0,0,1-3.24,1.563c-2.058,0-3.2-.915-3.183-2.783.019-2.364,2.383-3.508,5.3-3.508.667,0,1.334.058,1.791.1a1.344,1.344,0,0,0,.039-.381c0-.686-.667-1.239-1.754-1.239a6.008,6.008,0,0,0-3.106.762l.343-2.42A10.5,10.5,0,0,1-16.166-41c2.287,0,4.156.9,4.137,3.259,0,1.506-.858,3.659-1.239,6.557h-2.707Z"
            transform="translate(22.304 41)"
            fill="#004d71"
          />
        </g>
        <g id="g70" transform="translate(522.178 133.2)">
          <path
            id="path72"
            d="M-12.3,0H-8.95l-.534,2.44h-3.355Zm-.858,4h3.355l-2.04,9.588H-15.2Z"
            transform="translate(15.203)"
            fill="#004d71"
          />
        </g>
        <g id="g74" transform="translate(527.572 133.2)">
          <path
            id="path76"
            d="M-12.3,0h3.355l-2.9,13.591H-15.2Z"
            transform="translate(15.197)"
            fill="#004d71"
          />
        </g>
      </g>
    </svg>
  );
};

export default NRLogo;
